import api from './axiosConfig';

export const contentAPI = {
  getFlat: async () => {
    const response = await api.get('/content/flat');
    return response.data;
  },

  getAll: async () => {
    const response = await api.get('/content');
    return response.data;
  },

  getSection: async (section) => {
    const response = await api.get(`/content/${section}`);
    return response.data;
  },

  update: async (flatObject) => {
    const response = await api.put('/content', flatObject);
    return response.data;
  },

  uploadImage: async (field, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('field', field);
    const response = await api.post('/content/upload', formData);
    return response.data;
  },
};
